import React, { FunctionComponent } from 'react';
import { useCheckupRequest } from '../../hooks/useCheckupRequest';
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  QueryLoaderWrapper
} from '@companion-professional/components';
import { useCheckupUrl } from '../../hooks/useCheckupUrl';
import { CheckupDialogDisplayAndFooter } from '../CheckupDialogComponents';

interface CreateCheckupResultsProps {
  checkupId: string;
}

// CreateCheckupResults is the view displayed after a checkup has been created in a create checkup dialog (i.e. quick
// checkup or create checkup for pet).  It shows the checkup url, allows the user to copy it to the clipboard and
// displays a QR code that can be scanned to access the checkup.
export const CreateCheckupResults: FunctionComponent<CreateCheckupResultsProps> = ({ checkupId }) => {
  const { checkupRequest, error, isPending } = useCheckupRequest(checkupId);
  const { getCheckupUrl, error: getCheckupUrlError, isPending: getCheckupUrlIsPending } = useCheckupUrl();

  return (
    <DialogContent className="sm:max-w-md">
      <QueryLoaderWrapper
        isPending={isPending || getCheckupUrlIsPending}
        error={error || getCheckupUrlError}
        showChildrenOnError
      >
        {checkupRequest ? (
          <div className="flex flex-col space-y-5">
            <DialogHeader>
              <DialogTitle>Checkup Created</DialogTitle>
              <DialogDescription>
                Checkup has been created. You can now share the link below with your client or use your phone's camera
                to scan the QR code.
              </DialogDescription>
            </DialogHeader>
            <CheckupDialogDisplayAndFooter checkupUrl={getCheckupUrl(checkupId)} checkupId={checkupId} />
          </div>
        ) : null}
      </QueryLoaderWrapper>
    </DialogContent>
  );
};
